(
  function() {
    const faqContentContainer = document.querySelector('#FAQContentContainer');
    const faqNavBtnContentWrapper = document.querySelector('.faq-nav-btn-content__wrapper');
    const navButtonWrappers = document.querySelectorAll('.faq-nav-btn__wrapper');
    const collabsibleContentWrappers = document.querySelectorAll('.faq-collapsible-content__wrapper');
    const faqNavButtonsContainer = document.querySelector('.faq-nav-buttons__container');
    const faqCollapsibleContentContainer = document.querySelector('.faq-collapsible-content__container');
    const navReturnButton = document.querySelector('.nav-btn__return');

    // Register EventListener for nav buttons
    faqNavButtonsContainer.addEventListener('click', navBtnContainerCallback);
    navReturnButton.addEventListener('click', () => {
      faqNavBtnContentWrapper.classList.remove('show-content')
    });
    
  // Inject buttons and contents from template to container
    navButtonWrappers.forEach((template, i)=> injectContent(template, faqNavButtonsContainer, i));
    collabsibleContentWrappers.forEach((template, i) => injectContent(template, faqCollapsibleContentContainer, i));

  // Show faqContentContainer
    faqContentContainer.style.opacity = 1;

    // Get all nav buttons and content after injection completed
    const navButtons = faqNavButtonsContainer.querySelectorAll('.faq-nav-btn');
    const faqCollapsibleContents = faqCollapsibleContentContainer.querySelectorAll('.faq-collapsible-content');


    function injectContent(template, container, i) {
      const content = template.content.cloneNode(true);
      if(!i) content.firstElementChild.classList.add('active');
      container.appendChild(content);
    }

    function navBtnContainerCallback(e) {
      const targetElement = e.target;
      if(targetElement.tagName !== 'BUTTON') return;
      
      // Set active button
      navButtons.forEach(btn => btn.classList.toggle('active', btn === targetElement));

      // Set active button
      faqCollapsibleContents.forEach(content => content.classList.toggle('active', content.dataset.category === targetElement.textContent));

      // Show category content

      if(window.innerWidth < 990) faqNavBtnContentWrapper.classList.add('show-content');
    }
  }
)()